<div class="module-management">
  <!-- Header with buttons -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0">
      <i class="bi bi-puzzle me-2"></i>
      {{ 'SystemAdmin.moduleManagement' | translate }}
    </h5>
    
    <button type="button" class="btn btn-primary btn-sm" (click)="openCreateModal()">
      <i class="bi bi-plus-circle me-1"></i>
      {{ 'SystemAdmin.addModule' | translate }}
    </button>
  </div>

  <!-- Smart Grid -->
  <div class="row" *ngIf="columns.length > 0">
    <div class="col-12">
      <konti-smart-grid 
        [data]="modules?.rows || []" 
        [columns]="columns" 
        [initialSort]="[{ field: 'moduleName', dir: 'asc' }]"
        [showGroupPanel]="false"
        [showFilterTypePanel]="true">
        
        <!-- Actions column -->
        <ng-template appSmartGridCell="actions" let-row>
          <div class="action-capsule btn-group btn-group-sm sg-desktop-only">
            <button type="button" class="btn btn-outline-secondary" 
                    (click)="openEditModal(row)"
                    [title]="'General.edit' | translate">
              <i class="bi bi-pencil" aria-hidden="true"></i>
              <span class="visually-hidden">{{ 'General.edit' | translate }}</span>
            </button>
            <button type="button" class="btn btn-outline-danger action-danger" 
                    (click)="openDeleteModal(row)"
                    [title]="'General.delete' | translate">
              <i class="bi bi-trash3" aria-hidden="true"></i>
              <span class="visually-hidden">{{ 'General.delete' | translate }}</span>
            </button>
          </div>
        </ng-template>
      </konti-smart-grid>
    </div>
  </div>
</div>

<!-- Module Modal (Create/Edit) -->
<ng-template #moduleModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-puzzle me-2"></i>
      {{ (isEditing ? 'SystemAdmin.editModule' : 'SystemAdmin.addModule') | translate }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  
  <div class="modal-body">
    <form [formGroup]="moduleForm">
      <!-- Module ID (shown only when editing) -->
      <div class="mb-3" *ngIf="isEditing">
        <label class="form-label">{{ 'SystemAdmin.moduleID' | translate }}</label>
        <input type="text" class="form-control" formControlName="moduleID" readonly />
      </div>

      <!-- Module Name -->
      <div class="mb-3">
        <label class="form-label">
          {{ 'SystemAdmin.moduleName' | translate }} <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="moduleName" maxlength="50"
               [class.is-invalid]="f['moduleName'].invalid && f['moduleName'].touched" />
        <div class="invalid-feedback" *ngIf="f['moduleName'].invalid && f['moduleName'].touched">
          {{ 'General.required' | translate }}
        </div>
      </div>

      <!-- Module Version -->
      <div class="mb-3">
        <label class="form-label">{{ 'SystemAdmin.moduleVersion' | translate }}</label>
        <input type="text" class="form-control" formControlName="moduleVersion" maxlength="5" 
               placeholder="1.0" />
      </div>

      <!-- Module Description -->
      <div class="mb-3">
        <label class="form-label">{{ 'SystemAdmin.moduleDescription' | translate }}</label>
        <textarea class="form-control" formControlName="moduleDescription" rows="3" maxlength="5000"></textarea>
      </div>

      <!-- Module Template -->
      <div class="mb-3">
        <label class="form-label">{{ 'SystemAdmin.moduleTemplate' | translate }}</label>
        <input type="text" class="form-control" formControlName="moduleTemplate" maxlength="50" 
               placeholder="time-module" />
        <small class="text-muted">{{ 'SystemAdmin.moduleTemplateHint' | translate }}</small>
      </div>
    </form>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      {{ 'General.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="saveModule()">
      <i class="bi bi-save me-1"></i>
      {{ 'General.save' | translate }}
    </button>
  </div>
</ng-template>

<!-- Delete Confirmation Modal -->
<ng-template #deleteConfirmModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-exclamation-triangle text-danger me-2"></i>
      {{ 'General.confirmDelete' | translate }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  
  <div class="modal-body">
    <p>{{ 'SystemAdmin.confirmDeleteModule' | translate }}: <strong>{{ moduleToDelete?.moduleName }}</strong>?</p>
    <div class="alert alert-warning">
      <i class="bi bi-exclamation-triangle me-2"></i>
      {{ 'SystemAdmin.deleteModuleWarning' | translate }}
    </div>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      {{ 'General.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      <i class="bi bi-trash3 me-1"></i>
      {{ 'General.delete' | translate }}
    </button>
  </div>
</ng-template>
